import React from 'react';

import NarrativeChapter from './NarrativeChapter';

/**
 * Renders the selective-discovery narrative chapter. Accepts no props.
 *
 * @returns {React.ReactElement} Chapter one with approved copy and decorative
 *   conventional-dating fragments.
 * @sideEffects Has no external side effects beyond React rendering.
 */
export default function WindowChapter({ index = 2 }) {
  return (
    <NarrativeChapter
      index={index}
      id="window"
      title="A window, not a feed."
      body="Milan limits discovery to a small, curated window. No endless swiping, no volume game."
    >
      <div className="window-fragments" aria-hidden="true">
        <span className="window-slot">
          <span className="window-slot__badge">Keep browsing</span>
          <span className="window-slot__profile">
            <span className="window-slot__avatar">A</span>
            <span className="window-slot__traits">Nomadic • Books</span>
          </span>
        </span>
        <span className="window-slot window-slot--active">
          <span className="window-slot__badge">Someone new</span>
          <span className="window-slot__profile">
            <span className="window-slot__avatar">S</span>
            <span className="window-slot__traits">Established • Travel</span>
          </span>
        </span>
        <span className="window-slot">
          <span className="window-slot__badge">One more possibility</span>
          <span className="window-slot__profile">
            <span className="window-slot__avatar">J</span>
            <span className="window-slot__traits">Building • Music</span>
          </span>
        </span>
      </div>
    </NarrativeChapter>
  );
}
